export default __webpack_public_path__ + "static/media/daigaku.f0ef91dd.jpg";